import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import ListItemIcon from '@mui/material/ListItemIcon';
import PublicIcon from '@mui/icons-material/Public';
import * as api from '../api';
import * as analytics from '../analytics';

function CountrySelector({ selectedCountry, onSelectCountry }) {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCountries = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await api.fetchCountries();
        setCountries(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadCountries();
  }, []);

  if (loading) return <Typography>Loading countries...</Typography>;
  if (error) return <Typography color="error">Error: {error}</Typography>;

  const handleCountryChange = (e) => {
    const countryId = e.target.value;
    const country = countries.find(c => c.id === countryId);
    analytics.trackCountrySelected(countryId, country?.name);
    onSelectCountry(countryId);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="country-label">Country</InputLabel>
      <Select
        labelId="country-label"
        value={selectedCountry || ''}
        label="Country"
        onChange={handleCountryChange}
      >
        <MenuItem value="" disabled>Select country</MenuItem>
        {countries.map(country => (
          <MenuItem key={country.id} value={country.id}>
            <ListItemIcon>
              <PublicIcon fontSize="small" />
            </ListItemIcon>
            {country.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default CountrySelector; 